import React from 'react';
import {
  classNames,
  layoutClassNames,
  LayoutClassNameProps,
  surfaceClassNames,
  SurfaceShadow,
} from './classNames';

export interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement>, LayoutClassNameProps {
  rounded?: boolean;
  fluid?: boolean;
  fullHeight?: boolean;
  shadow?: SurfaceShadow;
  objectFit?: React.CSSProperties['objectFit'];
  maxHeight?: React.CSSProperties['maxHeight'];
}

const Image = React.forwardRef<HTMLImageElement, ImageProps>(({
  rounded = false,
  fluid = false,
  fullHeight = false,
  shadow,
  objectFit,
  maxHeight,
  alt = '',
  className,
  style,
  margin,
  marginTop,
  marginEnd,
  marginBottom,
  marginStart,
  marginX,
  marginY,
  padding,
  paddingTop,
  paddingEnd,
  paddingBottom,
  paddingStart,
  paddingX,
  paddingY,
  textAlign,
  ...props
}, ref) => (
  <img
    ref={ref}
    alt={alt}
    className={classNames(
      fluid ? 'img-fluid' : undefined,
      rounded ? 'rounded' : undefined,
      fullHeight ? 'h-100' : undefined,
      surfaceClassNames({ shadow }),
      layoutClassNames({
        margin,
        marginTop,
        marginEnd,
        marginBottom,
        marginStart,
        marginX,
        marginY,
        padding,
        paddingTop,
        paddingEnd,
        paddingBottom,
        paddingStart,
        paddingX,
        paddingY,
        textAlign,
      }),
      className,
    )}
    style={{
      ...(maxHeight !== undefined ? { maxHeight } : {}),
      ...(objectFit !== undefined ? { objectFit } : {}),
      ...style,
    }}
    {...props}
  />
));

Image.displayName = 'Image';

export default Image;
